let activeOrganizationId: string | null = null;

export const activeOrganizationVault = {
  clear() {
    activeOrganizationId = null;
  },
  get() {
    return activeOrganizationId;
  },
  set(organizationId: string) {
    activeOrganizationId = organizationId.trim() || null;
  },
};
